import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { forkJoin, Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { sort } from "d3";

@Injectable({
  providedIn: "root",
})
export class CrmService {
  constructor(private httpClient: HttpClient) { }

  create_lead_url = environment.host + "lead";

  createLead(leadData: any) {
    return this.httpClient.post(this.create_lead_url, leadData);
  }

  createOutboundLead(leadData: any) {
    return this.httpClient.post(environment.host + "org-lead/outbound", leadData);
  }
  updateOutboundLead(id: string, leadData: any) {
    return this.httpClient.patch(`${environment.host}org-lead/outbound/${id}`, leadData);
  }
  updateLead(leadData: any) {
    return this.httpClient.patch(this.create_lead_url, leadData);
  }

  uploadLead(formData: FormData) {
    return this.httpClient.post(
      this.create_lead_url + "/upload-leads",
      formData,
    );
  }
  getAllLead(option) {
    console.log({ option });
    const getall_leads_url =
      environment.host +
      `lead?page=${option.pageNum}&limit=${option.limit}${option.startDate === undefined || option.startDate === null
        ? ""
        : `&startDate=${option.startDate}`
      }${option.endDate === undefined || option.endDate === null
        ? ""
        : `&endDate=${option.endDate}`
      } ${option.leadStatus === undefined || option.leadStatus === null
        ? ""
        : `&leadStatus=${option.leadStatus}`
      }${option.representatorId === undefined || option.representatorId === null
        ? ""
        : `&representatorId=${option.representatorId}`
      }`;

    return this.httpClient.get(getall_leads_url);
  }

  getAllSearchedLead(option) {
    const get_search_leads_url =
      environment.host +
      `lead/search?search=${option.search}&page=${option.pageNum}&limit=${option.limit
      }${option.startDate === undefined || option.startDate === ""
        ? ""
        : `&startDate=${option.startDate}`
      }${option.endDate === undefined || option.endDate === ""
        ? ""
        : `&endDate=${option.endDate}`
      } `;
    return this.httpClient.get(get_search_leads_url);
  }

  getLeadDetail(id) {
    return this.httpClient.get(this.create_lead_url + "/" + id);
  }

  getSingleLead(id: string | number, project?: string, projectTab?: string, leadType?: string) {
    let url = `${environment.host}org-lead/${id}`;

    const uppercaseProject = (project || '').toUpperCase();
    const isOutbound =
      uppercaseProject === 'OUTBOUND' ||
      String(projectTab).toLowerCase() === 'outbound' ||
      String(leadType).toLowerCase() === 'outbound';

    if (isOutbound) {
      url += `?leadType=Outbound`;
    } else {
      const params: string[] = [];
      if (project && uppercaseProject !== 'ALL' && uppercaseProject !== 'OUTBOUND') {
        params.push(`project=${encodeURIComponent(project)}`);
      }
      if (projectTab && String(projectTab).toLowerCase() !== 'outbound') {
        params.push(`projectTab=${encodeURIComponent(projectTab)}`);
      }

      if (params.length) {
        url += `?${params.join('&')}`;
      }
    }

    return this.httpClient.get(url);
  }

  transferLead(leadId: string) {
    const url = `${environment.host}org-lead/${leadId}/transfer`;
    return this.httpClient.post(url, {});
  }
  getLeadsOverview(
    project?: string,
    startDate?: string,
    endDate?: string,
    isAll?: boolean,
    leadType?: string
  ) {
    let overview_url = `${environment.host}org-lead/overview`;

    const params: string[] = [];
    const upperProj = (project || '').toUpperCase();
    const isOutbound =
      upperProj === 'OUTBOUND' ||
      (leadType && leadType.toLowerCase() === 'outbound');

    if (isOutbound) {
      params.push(`leadType=Outbound`);
    } else if (isAll || !project || upperProj === 'ALL') {
      params.push(`isAll=true`);
    } else {
      params.push(`project=${project}`);
    }

    if (startDate) {
      params.push(`startDate=${startDate}`);
    }

    if (endDate) {
      params.push(`endDate=${endDate}`);
    }

    if (params.length) {
      overview_url += `?${params.join('&')}`;
    }

    return this.httpClient.get(overview_url);
  }



  deleteLeadById(id) {
    return this.httpClient.delete(this.create_lead_url + "/" + id);
  }

  openLeadsData(option) {
    const get_open_leads_url =
      environment.host +
      `analytics/lead/status?status=${option.startDate === undefined || option.startDate === ""
        ? ""
        : `&startDate=${option.startDate}`
      }${option.endDate === undefined || option.endDate === ""
        ? ""
        : `&endDate=${option.endDate}`
      }${option.representatorId === undefined || option.representatorId === null
        ? ""
        : `&representatorId=${option.representatorId}`
      }`;
    return this.httpClient.get(get_open_leads_url);
  }

  getFollowups(option) {
    const get_follow_ups_url =
      environment.host +
      `analytics/lead/follow-ups?page=${option.pageNumber}&limit=${option.limitCount}`;
    return this.httpClient.get(get_follow_ups_url);
  }




  // lead Tracking API's

  getAnyUsers(department: string) {
    const get_bd_users = environment.host + `users?department=${department}`;
    return this.httpClient.get(get_bd_users);
  }

  shareAccess(body: any) {
    const share_lead_url = environment.host + "org-lead/access";
    return this.httpClient.post(share_lead_url, body);
  }

  CheckLeadAccess(id: string) {
    const check_access_url = environment.host + "users" + "/" + id;
    return this.httpClient.get(check_access_url);
  }
  private formatOutboundPayload(body: any): any {
    if (!body || typeof body !== 'object') return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) return body;
    const payload = { ...body };
    const upperProj = (payload.project || "").toUpperCase();
    const isOutbound =
      upperProj === "OUTBOUND" ||
      payload.leadType === "Outbound" ||
      payload.leadType === "OUTBOUND" ||
      payload.projectTab === "Outbound" ||
      payload.source === "Outbound" ||
      payload.sourceLead === "Outbound" ||
      String(payload.projectTab).toLowerCase() === "outbound" ||
      String(payload.source).toLowerCase() === "outbound";

    if (isOutbound) {
      payload.leadType = "Outbound";
      delete payload.project;
      delete payload.projectTab;
    }
    return payload;
  }

  assignLead(body: any) {
    const assign_lead_url = environment.host + "org-lead/assign";
    const token = localStorage.getItem("guestToken") || localStorage.getItem("token") || "";
    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      headers.guestToken = token;
      headers.token = token;
    }
    return this.httpClient.post(assign_lead_url, this.formatOutboundPayload(body), { headers });
  }

  unassignLead(body: any) {
    const unassign_lead_url = environment.host + "org-lead/unassign";
    const token = localStorage.getItem("guestToken") || localStorage.getItem("token") || "";
    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      headers.guestToken = token;
      headers.token = token;
    }
    return this.httpClient.post(unassign_lead_url, this.formatOutboundPayload(body), { headers });
  }

  reassignLead(body: any) {
    const reassign_lead_url = environment.host + "org-lead/reassign";
    const token = localStorage.getItem("guestToken") || localStorage.getItem("token") || "";
    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      headers.guestToken = token;
      headers.token = token;
    }
    return this.httpClient.post(reassign_lead_url, this.formatOutboundPayload(body), { headers });
  }

  deleteLead(project, projectTab: string, leadId: string) {
    const delete_lead_url = environment.host + 'org-lead';

    return this.httpClient.delete(delete_lead_url, {
      body: this.formatOutboundPayload({ project, projectTab, leadId })
    });
  }

  deleteIICLabLead(source: string, leadId: string) {
    const delete_lead_url = environment.host + 'iic-lab';
    return this.httpClient.delete(delete_lead_url, {
      body: { leadId, source }
    });
  }


  private resolveProjectForSource(source?: string): string | undefined {
    if (!source) {
      return undefined;
    }

    const normalizedSource = source.trim().toLowerCase();
    const vRetailSources = new Set([
      'book demo',
      'user onboard',
      'lead magnet features',
      'lead magnet book demo',
      'lead magnet pricing'
    ]);
    const vEstateSources = new Set(['whatsapp', 'ivr', 'ads']);
    const iicLabSources = new Set(['news letter', 'newsletter', 'career']);

    if (vRetailSources.has(normalizedSource)) {
      return 'V-RETAIL';
    }

    if (vEstateSources.has(normalizedSource)) {
      return 'V-ESTATE';
    }

    if (iicLabSources.has(normalizedSource)) {
      return 'IIC-LAB';
    }

    if (normalizedSource === 'contact us') {
      // Contact Us exists across projects; choose the most likely matching project
      return 'V-RETAIL';
    }

    return undefined;
  }

  getAdminAssignedLead(params: {
    project?: string;
    isAll?: boolean;
    pageNum: number;
    limit: number;
    status?: string;
    isDeleted?: boolean;
    sort?: number;
    startDate?: string;
    endDate?: string;
    projectTab?: string;
    searchQuery?: string;
    customerValue?: string;
    hasClosingPotential?: boolean;
  }) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('guestToken')}`,
    });

    const queryParams: any = {
      page: params.pageNum,
      limit: params.limit,
      sort: params.sort ?? -1
    };

    const upperProj = (params.project || '').toUpperCase();
    const isAll = params.isAll || upperProj === 'ALL';

    if (upperProj === 'OUTBOUND' || (params as any).leadType === 'Outbound') {
      queryParams.leadType = 'Outbound';
    } else if (isAll) {
      queryParams.isAll = true;
    } else if (params.project && upperProj !== 'ALL') {
      queryParams.project = params.project;
    } else if (!isAll && !params.project && params.projectTab) {
      const resolvedProject = this.resolveProjectForSource(params.projectTab);
      if (resolvedProject) {
        queryParams.project = resolvedProject;
      }
    }

    if (!isAll && params.projectTab && params.projectTab !== 'ALL') {
      queryParams.projectTab = params.projectTab;
    }

    if (params.status && !params.isDeleted) {
      queryParams.status = params.status;
    }

    if (params.isDeleted === true) {
      queryParams.isDeleted = true;
    }

    if (params.startDate) {
      queryParams.startDate = params.startDate;
    }

    if (params.endDate) {
      queryParams.endDate = params.endDate;
    }

    const searchVal = params.searchQuery !== undefined ? params.searchQuery : (params as any).name;
    if (searchVal) {
      queryParams.searchQuery = searchVal;
    }

    if (params.customerValue) {
      queryParams.customerValue = params.customerValue.toLowerCase();
    }

    if (params.hasClosingPotential !== undefined) {
      queryParams.hasClosingPotential = params.hasClosingPotential;
    }

    return this.httpClient.get(
      `${environment.host}org-lead/assigned-leads`,
      {
        params: queryParams,
        headers
      }
    );
  }


  getAssignedLead(params: any) {
    const queryParams: any = {
      page: params.pageNum ?? params.page ?? 1,
      limit: params.limit,
      sort: params.sort ?? -1
    };

    const upperProj = (params.project || '').toUpperCase();
    const isAll = params.isAll || upperProj === 'ALL';

    if (upperProj === 'OUTBOUND' || params.leadType === 'Outbound') {
      queryParams.leadType = 'Outbound';
    } else if (isAll) {
      queryParams.isAll = true;
    } else if (params.project && upperProj !== 'ALL') {
      queryParams.project = params.project;
    } else if (!isAll && !params.project && params.projectTab) {
      const resolvedProject = this.resolveProjectForSource(params.projectTab);
      if (resolvedProject) {
        queryParams.project = resolvedProject;
      }
    }

    if (!isAll && params.projectTab && params.projectTab !== 'ALL') {
      queryParams.projectTab = params.projectTab;
    }

    if (params.startDate) queryParams.startDate = params.startDate;
    if (params.endDate) queryParams.endDate = params.endDate;
    if (params.status && !params.isDeleted) {
      queryParams.status = params.status;
    }
    if (params.isDeleted === true) queryParams.isDeleted = true;

    const searchVal = params.searchQuery !== undefined ? params.searchQuery : params.name;
    if (searchVal) queryParams.searchQuery = searchVal;
    if (params.isActive !== undefined) queryParams.isActive = params.isActive;
    if (params.customerValue) queryParams.customerValue = params.customerValue.toLowerCase();
    if (params.hasClosingPotential !== undefined) queryParams.hasClosingPotential = params.hasClosingPotential;

    return this.httpClient.get(
      `${environment.host}org-lead/assigned-leads`,
      { params: queryParams }
    );
  }




  getSalesUser() {
    const sales_url = environment.host + "org-lead/users-list";
    const token = localStorage.getItem("guestToken") || localStorage.getItem("token") || "";
    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      headers.guestToken = token;
      headers.token = token;
    }
    return this.httpClient.get(sales_url, { headers });
  }

  getUsersList() {
    return this.getSalesUser();
  }

  updatefollowUpLead(payload: any) {
    const url = environment.host + "org-lead";
    return this.httpClient.patch(url, this.formatOutboundPayload(payload));
  }

  updateSalesLead(payload: any) {
    const url = environment.host + "org-lead/update";
    return this.httpClient.patch(url, this.formatOutboundPayload(payload));
  }

  createFollowUp(payload: any) {
    const url = environment.host + "org-lead/follow-up-meeting";
    return this.httpClient.post(url, this.formatOutboundPayload(payload));
  }

  createFollowUpTask(payload: any) {
    const url = environment.host + "org-lead/follow-up-tasks";
    const body = { ...payload };
    if (!body.redirectUrl) {
      const proj = String(body.project || 'V-RETAIL').toUpperCase();
      let path = 'all-leads';
      if (proj.includes('IIC')) path = 'iic-leads';
      else if (proj.includes('ESTATE')) path = 'vestate-leads';
      else if (proj.includes('OUTBOUND')) path = 'outbound-leads';
      else if (proj.includes('RETAIL')) path = 'vretail-leads';
      body.redirectUrl = `${environment.redirectUrl}#/lead-track/${path}?view=kanban`;
    }
    const token = localStorage.getItem("guestToken") || localStorage.getItem("token") || "";
    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      headers.guestToken = token;
      headers.token = token;
    }
    return this.httpClient.post(url, body, { headers });
  }

  getFollowUpLeads(params: any) {
    const queryParams: any = {
      page: params.pageNum ?? params.page ?? 1,
      limit: params.limit ?? 500,
      sort: params.sort ?? -1
    };

    const upperProj = (params.project || '').toUpperCase();
    const isAll = params.isAll || upperProj === 'ALL';

    if (upperProj === 'OUTBOUND' || params.leadType === 'Outbound') {
      queryParams.leadType = 'Outbound';
    } else if (isAll) {
      queryParams.isAll = true;
    } else if (params.project && upperProj !== 'ALL') {
      queryParams.project = params.project;
    }

    if (!isAll && params.projectTab && params.projectTab !== 'ALL') {
      queryParams.projectTab = params.projectTab;
    }

    if (params.startDate) queryParams.startDate = params.startDate;
    if (params.endDate) queryParams.endDate = params.endDate;
    const searchVal = params.searchQuery !== undefined ? params.searchQuery : params.name;
    if (searchVal) queryParams.searchQuery = searchVal;
    if (params.customerValue) queryParams.customerValue = params.customerValue.toLowerCase();

    return this.httpClient.get(
      `${environment.host}org-lead/follow-up-leads`,
      { params: queryParams }
    );
  }



  getFollowUp(field: {
    project?: string;
    leadType?: string;
    isAll?: boolean;
    status?: string;
    page?: number;
    limit?: number;
    leadId?: string;
  }) {
    let url = `${environment.host}org-lead/follow-up-meeting`;
    const params: string[] = [];
    const upperProj = (field.project || '').toUpperCase();
    const standardProjects = ['IIC-LAB', 'IIC', 'V-RETAIL', 'V-ESTATE'];

    const isOutbound =
      upperProj === 'OUTBOUND' ||
      String(field.leadType).toLowerCase() === 'outbound' ||
      String((field as any).projectTab).toLowerCase() === 'outbound' ||
      (field.leadId && field.project && !standardProjects.includes(upperProj) && upperProj !== 'ALL');

    if (isOutbound) {
      params.push(`leadType=Outbound`);
    } else if (field.isAll || upperProj === 'ALL' || !field.project) {
      params.push(`isAll=true`);
    } else {
      params.push(`project=${field.project}`);
      if ((field as any).projectTab && String((field as any).projectTab).toLowerCase() !== 'outbound') {
        params.push(`projectTab=${encodeURIComponent((field as any).projectTab)}`);
      }
    }

    if (field.leadId) {
      params.push(`leadId=${field.leadId}`);
    }

    if (field.status) {
      params.push(`status=${encodeURIComponent(field.status)}`);
    }

    if (field.page) {
      params.push(`page=${field.page}`);
    }

    if (field.limit) {
      params.push(`limit=${field.limit}`);
    }

    if (params.length) {
      url += `?${params.join('&')}`;
    }

    return this.httpClient.get(url);
  }


  updateFollowUp(
    field: { project?: string; isAll?: boolean; status?: string },
    body: any
  ) {
    let url = `${environment.host}org-lead/follow-up-meeting`;
    const params: string[] = [];
    const upperProj = (field.project || '').toUpperCase();

    if (upperProj === 'OUTBOUND' || (field as any).leadType === 'Outbound') {
      params.push(`leadType=Outbound`);
    } else if (field.isAll || upperProj === 'ALL' || !field.project) {
      params.push(`isAll=true`);
    } else {
      params.push(`project=${field.project}`);
    }

    if (field.status) {
      params.push(`status=${field.status}`);
    }

    if (params.length) {
      url += `?${params.join('&')}`;
    }

    return this.httpClient.patch(url, this.formatOutboundPayload(body));
  }

  getCalendar(field: { year: number; project?: string; isAll?: boolean; leadType?: string }) {
    let url = `${environment.host}org-lead/calendar-data?year=${field.year}`;
    const upperProj = (field.project || '').toUpperCase();

    if (upperProj === 'OUTBOUND' || field.leadType === 'Outbound') {
      url += `&leadType=Outbound`;
    } else if (field.isAll || upperProj === 'ALL') {
      url += `&isAll=true`;
    } else if (field.project) {
      url += `&project=${field.project}`;
    }

    return this.httpClient.get<any>(url);
  }

  searchLeadList(type: any) {
    let url = `${environment.host}org-lead/search`;
    const params: string[] = [];
    const upperProj = (type.project || '').toUpperCase();
    const normalizedProject = type.project && upperProj !== 'ALL' ? type.project : undefined;

    if (upperProj === 'OUTBOUND' || type.leadType === 'Outbound') {
      params.push(`leadType=Outbound`);
    } else if (type.isAll || upperProj === 'ALL') {
      params.push(`isAll=true`);
    } else if (normalizedProject) {
      params.push(`project=${normalizedProject}`);
    }

    if (type.startDate) params.push(`startDate=${type.startDate}`);
    if (type.endDate) params.push(`endDate=${type.endDate}`);

    params.push(`page=${type.pageNum || 1}`);
    // The all-projects result set is substantially larger. Keep each request
    // small so rendering the initial page does not block the UI thread.
    params.push(`limit=${type.isAll || type.project === 'ALL' ? 20 : type.limit || 100}`);

    if (type.projectTab && type.projectTab !== 'ALL') {
      params.push(`projectTab=${encodeURIComponent(type.projectTab)}`);
    }

    const searchQuery = type.searchQuery !== undefined ? type.searchQuery : type.name;
    if (searchQuery) params.push(`searchQuery=${encodeURIComponent(searchQuery)}`);
    if (type.assignedTo) params.push(`assignedTo=${type.assignedTo}`);
    if (type.status && !type.isDeleted) params.push(`status=${encodeURIComponent(type.status)}`);

    if (type.unAssigned === true) {
      params.push(`unAssigned=true`);
    }

    if (type.isDeleted === true) {
      params.push(`isDeleted=true`);
    }

    if (type.hasClosingPotential === true || type.hasClosingPotential === 'true') {
      params.push(`hasClosingPotential=true`);
    }

    url += `?${params.join("&")}`;
    // console.log("FINAL URL:", url);

    return this.httpClient.get(url);
  }

  createNote(body: any) {
    let payload = body ? { ...body } : {};
    const upperProj = (payload.project || '').toUpperCase();
    if (upperProj === 'OUTBOUND' || payload.leadType === 'Outbound' || payload.leadType === 'OUTBOUND') {
      payload.leadType = 'Outbound';
      delete payload.project;
    }
    return this.httpClient.post(environment.host + "org-lead/note", payload);
  }

  getNote(field) {
    const upperProj = (field?.project || '').toUpperCase();
    if (upperProj === 'ALL' || field?.isAll) {
      return of(null);
    }
    let get_note_url = `${environment.host}org-lead/note`;
    if (upperProj === 'OUTBOUND' || field?.leadType === 'Outbound') {
      get_note_url += `?leadType=Outbound`;
    } else if (field?.project) {
      get_note_url += `?project=${field.project}`;
    }
    return this.httpClient.get(get_note_url);
  }

  exportExcel(opt) {
    const upperProj = (opt?.project || '').toUpperCase();
    let export_lead_url = environment.host + 'org-lead/export?';

    if (upperProj === 'OUTBOUND' || opt?.leadType === 'Outbound') {
      export_lead_url += `leadType=Outbound`;
    } else {
      export_lead_url += `project=${opt.project}`;
    }
    if (opt.projectTab) export_lead_url += `&projectTab=${opt.projectTab}`;
    if (opt.startDate) export_lead_url += `&startDate=${opt.startDate}`;
    if (opt.endDate) export_lead_url += `&endDate=${opt.endDate}`;
    return this.httpClient.get(export_lead_url);
  }

  exportCareerExcel(opt) {
    const export_career_lead_url =
      environment.host +
      `iic-lab/career-csv?page=${opt.pageNum}&limit=${opt.limit}${opt.startDate === undefined || opt.startDate === ""
        ? ""
        : `&startDate=${opt.startDate}`
      }${opt.endDate === undefined || opt.endDate === ""
        ? ""
        : `&endDate=${opt.endDate}`
      }&currentJobRole=${opt.currentJobRole}&name=${opt.name}&experience=${opt.experience}`;
    return this.httpClient.get(export_career_lead_url);
  }

  updateLeadStatus(body: any) {
    const update_status_url = environment.host + "org-lead";
    return this.httpClient.patch(update_status_url, this.formatOutboundPayload(body));
  }
  getCareerList(field: any) {
    let url =
      `${environment.host}iic-lab/career-list` +
      `?sort=-1&page=${field.pageNum}&limit=${field.limit}`;

    if (field.name) {
      url += `&name=${encodeURIComponent(field.name)}`;
    }

    if (field.isDeleted === true) {
      url += `&isDeleted=true`;
    }

    return this.httpClient.get(url);
  }


  getPreSignedUrls(fileName: string, totalChunks: number, fileSize: number, leadId: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
    });

    return this.httpClient.post(
      `${environment.host}org-lead/presigned-url`,
      {
        files: [
          {
            fileName,
            totalChunks,
            fileSize
          }
        ],
        leadId: leadId
      },
      { headers }
    );
  }

  completeUpload(files: any[], leadId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
    });

    const body = {
      leadId,
      files: files.map(f => ({
        uniqueFileName: f.uniqueFileName,
        uploadId: f.uploadId,
        mediaId: f.mediaId,
        parts: f.parts.map((p: any) => ({
          PartNumber: p.PartNumber,
          ETag: p.ETag
        }))
      }))
    };

    return this.httpClient.post(
      `${environment.host}org-lead/complete-upload`,
      body,
      { headers }
    );
  }

  updateDragStatus(body: any) {
    const status_url = environment.host + "org-lead/status";
    return this.httpClient.patch(status_url, this.formatOutboundPayload(body));
  }

  leadsBreakdown(field: { project?: string; leadType?: string; isAll?: boolean; startDate?: string; endDate?: string }) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
    });
    let url = `${environment.host}org-lead/breakdown`;

    const params: string[] = [];
    const upperProj = (field.project || '').toUpperCase();

    if (upperProj === 'OUTBOUND' || field.leadType === 'Outbound') {
      params.push(`leadType=Outbound`);
    } else if (field.isAll || upperProj === 'ALL') {
      params.push(`isAll=true`);
    } else if (field.project) {
      params.push(`project=${field.project}`);
    }

    if (field.startDate) params.push(`startDate=${field.startDate}`);
    if (field.endDate) params.push(`endDate=${field.endDate}`);

    if (params.length) url += `?${params.join("&")}`;

    return this.httpClient.get(url, { headers });
  }

  deleteLeadMedia(mediaId: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem("guestToken")}`,
    });
    const url = `${environment.host}org-lead/${mediaId}`;
    return this.httpClient.delete(url, { headers });
  }

  restoreLead(payload: any) {
    const restore_lead_url = environment.host + 'org-lead/restore';
    return this.httpClient.post(restore_lead_url, this.formatOutboundPayload(payload));
  }

  restoreIICLabLead(source: string, leadId: string) {
    const restore_lead_url = environment.host + 'iic-lab/restore';
    return this.httpClient.post(restore_lead_url, { source, leadId });
  }

  createDisposition(body: any) {
    const url = environment.host + "org-lead/disposition-status";
    return this.httpClient.post(url, this.formatOutboundPayload(body));
  }

  createFollowUpReminder(body: any) {
    const url = environment.host + "org-lead/follow-up-reminders";
    return this.httpClient.post(url, this.formatOutboundPayload(body));
  }

  getFollowUpReminders(params: {
    project?: string;
    leadType?: string;
    isAll?: boolean;
    status?: string;
    page?: number;
    limit?: number;
    projectTab?: string;
    searchQuery?: string;
    startDate?: string;
    endDate?: string;
  }) {
    const url = `${environment.host}org-lead/follow-up-reminders`;
    const queryParams: any = {};

    if (params.page !== undefined) queryParams.page = params.page;
    if (params.limit !== undefined) queryParams.limit = params.limit;

    const upperProj = (params.project || '').toUpperCase();
    const isOutbound =
      upperProj === 'OUTBOUND' ||
      String(params.leadType).toLowerCase() === 'outbound' ||
      String(params.projectTab).toLowerCase() === 'outbound';

    if (isOutbound) {
      queryParams.leadType = 'Outbound';
    } else if (params.project && upperProj !== 'ALL') {
      queryParams.project = params.project;
      if (params.projectTab && String(params.projectTab).toLowerCase() !== 'outbound' && params.projectTab !== 'ALL') {
        queryParams.projectTab = params.projectTab;
      }
    }

    if (params.status) {
      queryParams.status = params.status;
    }

    if (params.startDate) queryParams.startDate = params.startDate;
    if (params.endDate) queryParams.endDate = params.endDate;
    const searchVal = params.searchQuery !== undefined ? params.searchQuery : (params as any).name;
    if (searchVal) queryParams.searchQuery = searchVal;

    return this.httpClient.get(url, { params: queryParams });
  }

  deleteDisposition(id: string) {
    const url = environment.host + `org-lead/disposition-status/${id}`;
    return this.httpClient.delete(url);
  }

  updateFollowUpTask(taskId: string, body: any) {

    const url = `${environment.host}org-lead/follow-up-task/${taskId}`;
    return this.httpClient.patch(url, body);
  }

  updateFollowUpReminder(reminderId: string, body: any) {
    const url = `${environment.host}org-lead/follow-up-reminders/${reminderId}`;
    return this.httpClient.patch(url, this.formatOutboundPayload(body));
  }
}

